export class FeatureFlag {
	public id: number;
	public name: string;
	public onName: string;
	public offName: string;

	constructor(featureFlag?: FeatureFlag) {
		Object.assign(this, featureFlag);
	}
}
